import { Subscribable, Subscription } from '@benzinga/subscribable';
import { QuoteSocket, QuoteSocketEvent } from './socket';
import { Quote, Security } from './entities';
import { normalizeQuoteInPlace } from './utils';

interface QuoteEvent {
  quote: Quote;
  type: 'quote';
}

export type QuoteSessionEvents = QuoteEvent;
export class QuoteSession extends Subscribable<QuoteSessionEvents> {
  private socket: QuoteSocket;
  private security: Security;
  private socketSubscription?: Subscription<QuoteSocket>;
  private fields = new Set<keyof Quote>();

  constructor(quoteSocket: QuoteSocket, security: Security) {
    super();
    this.socket = quoteSocket;
    this.security = security;
  }

  public getSecurity = (): Security => this.security;
  public getFields = (): Set<keyof Quote> => this.fields;

  public updateFields = (fields: Set<keyof Quote>): void => {
    this.fields = fields;
    if (this.fields.size > 0) {
      this.socket.updateSession(this);
    } else {
      this.socket.endSession(this);
    }
  };

  protected override onFirstSubscription(): void {
    this.socketSubscription = this.socket.subscribe(this.socketCallback);
    if (this.fields.size > 0) {
      this.socket.updateSession(this);
    }
  }

  protected override onZeroSubscriptions(): void {
    this.socket.endSession(this);
    this.socketSubscription?.unsubscribe();
    this.socketSubscription = undefined;
  }

  private socketCallback = (event: QuoteSocketEvent): void => {
    switch (event.type) {
      case 'quote':
        if (event.quote.symbol === this.security) {
          normalizeQuoteInPlace(event.quote);
          this.dispatch(event as QuoteEvent);
        }
        break;
      case 'reconnected':
        if (this.fields.size > 0) {
          this.socket.updateSession(this);
        }
        break;
    }
  };
}
